<template>
  <div style="width: 1200px;margin: 0 auto;height: 100%">
    <div style="line-height: 45px;">
    <div style="font-weight:bold;text-align: center;font-size:25px;">{{ this.title }}</div>
    <div class="pa" style=" padding-bottom:17px;" ><span>浏览量:{{this.browse}}</span><span style="padding-left: 20px">发布日期:  {{this.create_time}}</span></div>
    <div style="border-bottom: 1px dashed #ccc;margin-bottom: 20px;margin-top: -15px;"></div>
  </div>
    <div class="pa" style="padding-bottom: 20px;text-align: justify;" v-html="this.content"></div>
  </div>
</template>
<script>
export default {
  name: "Newsparticulars",
  data() {
    return {
      content:'',
      userName:'',
      pageViews:'',
      browse:'',
      create_time:'',
      title:''
    }
  },
  created() {
    console.log(this.$route.query.id)
    if(this.$route.query.id){
        let id = this.$route.query.id
        this.news(id);
      }
    // if(sessionStorage.getItem("content")){
    //   if(this.$route.query.id){
    //     let id = this.$route.query.id
    //     this.news(id);
    //   }else{
    //     this.content = sessionStorage.getItem("content")
    //   }
    //   if(sessionStorage.getItem("userName") != 'undefined'){
    //     this.pageViews = sessionStorage.getItem("pageViews")
    //     this.userName = sessionStorage.getItem("userName")
    //   }
    // }else{
    //   if(this.$route.params.content){
    //     this.content = this.$route.params.content
    //   }else{
    //     let id = this.$route.query.id
    //     this.news(id);
    //   }
    //   this.userName = this.$route.params.userName
    //   this.pageViews = this.$route.params.pageViews
    //   sessionStorage.setItem("content", this.content);
    //   sessionStorage.setItem("userName", this.userName);
    //   sessionStorage.setItem("pageViews", this.pageViews);
    // }


    // if(this.content.substring((this.content.length - 12) ==='.pdf</a></p>')){
    //   console.log(this.content.substring(this.content.length - 12))
    //       window.open(
    //        // this.content,
    //        "https://docs.google.com/viewer?url=" + this.content,
    //         // "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(this.content) ,
    //       "_blank")
    //   }
  },
  beforeDestroy() {
    sessionStorage.removeItem('content')
  },
  methods: {
    news(id){
      let params = {
        'id':id,
      }
      this.axios.post('/api/index/getinfo',params).then((response) => {
        console.log(response)
        if(response.data.msg == 'success'){
          this.content = response.data.data.message
          this.browse=response.data.data.browse
          this.create_time=response.data.data.create_time
          this.title=response.data.data.title
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
  },
  mounted(){

  }
}
</script>

<style scoped>
.pa /deep/ p{
  margin-top: 0px;
  margin-bottom: 0px;
}
.pa /deep/ p img{
  width: 1000px;
  /*height: 700px;*/
  /* display: flex; */

  /*margin:0px 0;*/
}
</style>



// WEBPACK FOOTER //
// src/components/view/Newsparticulars.vue